export enum DossierStatusEnum {
  DRAFT = 'DRAFT', // В редакции
  ACTIVE = 'ACTIVE', // Активно - Выполнение операции "Завершение редактирование"
  ARCHIVED = 'ARCHIVED', // Архив
  DELETED = 'DELETED', // Удалено - Удаление досье
  CLOSED = 'CLOSED' //Закрыто
}
